import { Card } from "@mui/material";
import { UseIsConfiguredToOtherSiteResult } from "../../hooks/useIsConfiguredToOtherSite";

export interface RANoDataFoundConfig extends Partial<UseIsConfiguredToOtherSiteResult> {
  isGBPConnected?: boolean;
  isNotMapped?: boolean;
}

interface RANoDataFoundProps {
  isEnabled?: boolean;
  alreadyConfigured?: RANoDataFoundConfig;
}

export default function RANoDataFound({ isEnabled = false, alreadyConfigured }: RANoDataFoundProps) {
  const isConfiguredToOtherSite = Boolean(alreadyConfigured?.isConfiguredToOtherSite);
  const configuredSiteURL = alreadyConfigured?.siteURL;
  const isSiteConfiguredToOtherGbp = Boolean(alreadyConfigured?.isSiteConfiguredToOtherGbp);
  const configuredGbpName = alreadyConfigured?.configuredGbpName;
  const isGBPConnected = alreadyConfigured?.isGBPConnected ?? true;
  const isNotMapped = Boolean(alreadyConfigured?.isNotMapped);

  const title = isSiteConfiguredToOtherGbp
    ? "Site is Already Configured to Another Google Business Profile"
    : isConfiguredToOtherSite
    ? "Google Business Profile Already Configured"
    : !isGBPConnected
    ? "GBP Not Connected"
    : isNotMapped
    ? "Site and Google Business Profile Not Connected"
    : "No Review Automation Data Found";

  const description = isSiteConfiguredToOtherGbp
    ? (configuredGbpName
        ? `This site is already configured with another Google Business Profile: ${configuredGbpName}`
        : "This site is already configured with another Google Business Profile.")
    : isConfiguredToOtherSite
    ? (configuredSiteURL
        ? `This Google Business Profile is already configured with another site: ${configuredSiteURL}`
        : "This Google Business Profile is already configured with another site.")
    : !isGBPConnected
    ? "Google Business Profile is not connected. Connect your Google Business Profile to enable Review Automation."
    : isNotMapped
    ? "This site and Google Business Profile are not connected. Please connect or map a Google Business Profile to enable Review Automation."
    : (isEnabled
        ? "No review activity or summary data has been generated yet for this location."
        : "It looks like Review Automation is currently disabled for this location. Toggle 'Enable Automation' above to start automated review responses.");

  return (
    <Card sx={{ mt: 3, boxShadow: "2px 2px 12px 2px rgba(0,0,0,0.06)" }}>
      <div className="px-6 py-12 flex flex-col items-center justify-center text-center">
        <h3 className="font-medium text-lg text-[#1D2939] mb-1">
          {title}
        </h3>
        <p className="font-normal text-sm leading-5 text-[#667085] max-w-md">
          {description}
        </p>
      </div>
    </Card>
  );
}
